import { render, staticRenderFns } from "./ModalDetail.vue?vue&type=template&id=69b169f1&"
import script from "./ModalDetail.vue?vue&type=script&lang=js&"
export * from "./ModalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports